import { render, staticRenderFns } from "./cusAddress.vue?vue&type=template&id=33b70084&scoped=true"
import script from "./cusAddress.vue?vue&type=script&lang=js"
export * from "./cusAddress.vue?vue&type=script&lang=js"
import style0 from "./cusAddress.vue?vue&type=style&index=0&id=33b70084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b70084",
  null
  
)

export default component.exports